export default {
    BLUE:   '#b5c9f0',
    RED:    '#ff9cb7',
    GRAY:   '#A9ABAE',
    GREEN:  '#0b6365',//'#1eb5aa',//'#00d7c7',
    DARK_GREEN:  '#0d9aad',//'#1ca99e'//'#00d7c7',
    EXTRA_DARK_GREEN:  '#0f7280'//'#1ca99e'//'#00d7c7',
}